var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVcIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.21468 11.3804L5.83464 6.76041V8.41125L2.03718 12.2029C1.83885 12.1504 1.65801 12.0454 1.51218 11.9054C1.37218 11.7595 1.26718 11.5787 1.21468 11.3804Z",
    fill: "#696F88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83464 2.264L1.16797 6.93063V8.58146L5.83464 3.91484V2.264Z",
    fill: "#696F88"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33464 1.75065C1.69297 1.75065 1.16797 2.27565 1.16797 2.91732V4.08398L3.5013 1.75065H2.33464Z",
    fill: "#696F88"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.83716 12.2507L5.83464 12.2506V11.2532L4.83716 12.2507Z",
    fill: "#696F88"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83464 0.583984H7.0013V13.4173H5.83464V0.583984Z",
    fill: "#696F88"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16797 4.08398V2.91732H10.5013V1.75065H11.668V2.91732H12.8346V4.08398H11.668V9.91732H12.8346V11.084H11.668V12.2507H10.5013V11.084H8.16797V9.91732H10.5013V4.08398L8.16797 4.08398Z",
    fill: "#696F88"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVcIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/vc_icon.f341cc92d656c4b44aa135e298e8d45e.svg";